import React from 'react'

function Industries() {
  return (
    <div>Industries</div>
  )
}

export default Industries